import { customAxios as axios, getToken } from '../../../request'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import {
  exportAgentContractListUrl,
  getAgentFanTourListUrl,
  getAgentSignedContractListUrl,
  getAllNewScheduleMeetingsUrl,
  getPerformanceReportUrl, updateMarketingUserInAllAgentUrl, updateMarketingUserInZeroCaseAgentUrl
} from '../apis'
import { notification } from 'antd'

export const getAgentPerformanceReportFxn = (filters) => async (dispatch) => {
  // dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...await getToken()
  }
  let resp = await axios.get(getPerformanceReportUrl(), config)
  dispatch(hidePageLoad())
  return resp
}

export const getAllNewScheduleMeetingsFxn = (filters) => async (dispatch) => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...await getToken()
  }
  let { data } = await axios.get(getAllNewScheduleMeetingsUrl(), config)
  dispatch(hidePageLoad())
  return data
}

export const getAgentSignedContractFxn = (filters) => async (dispatch) => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...await getToken()
  }
  let resp = await axios.get(getAgentSignedContractListUrl(), config)
  dispatch(hidePageLoad())
  return resp
}
export const getCyprusFamTourListFxn = (filters) => async (dispatch) => {
  dispatch(showPageLoad())
  let config = {
    params: { ...filters },
    ...await getToken()
  }
  let resp = await axios.get(getAgentFanTourListUrl(), config)
  dispatch(hidePageLoad())
  return resp
}

export const updateMarketingUserForAllAgentsFxn = (valData) => async dispatch => {
  dispatch(showPageLoad())
  try {
    const res = await axios.post(updateMarketingUserInAllAgentUrl(), valData, getToken())
    const data = res.data

    if (data.success) {
      notification.success({
        message: data.message || 'Updated Successfully'
      })
    } else {
      notification.error({
        message: data.message || 'Error updating'
      })
    }

    return data
  } catch (err) {
    notification.error({
      message: 'Error updating marketing user'
    })
    return { success: false }
  } finally {
    dispatch(hidePageLoad())
  }
}

export const exportAgentSignedContractListFxn = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(exportAgentContractListUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data && data.success) {
    notification.success({ message: data.message })
  } else {
    notification.error({ message: data.message })
  }
  return data
}

export const updateMarketingUserForZeroCaseAgentsFxn = (valData) => async dispatch => {
  dispatch(showPageLoad())
  try {
    const res = await axios.post(updateMarketingUserInZeroCaseAgentUrl(), valData, getToken())
    const data = res.data

    if (data.success) {
      notification.success({
        message: data.message || 'Updated Successfully'
      })
    } else {
      notification.error({
        message: data.message || 'Error updating'
      })
    }

    return data
  } catch (err) {
    notification.error({
      message: 'Error updating marketing user'
    })
    return { success: false }
  } finally {
    dispatch(hidePageLoad())
  }
}
